import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { WriteReviewModalComponent } from 'src/app/courses/write-review/write-review-modal.component';
import { CEUCountPipe } from 'src/app/_helpers/extensions.module';
import { Enums } from 'src/app/_models/generatedEnums';
import { CEUEventSummary, ConferenceViewModel, ParticipationModality } from 'src/app/_models/generatedModels';
import { CEUService, OrganizationService } from 'src/app/_services/generatedServices';
import { ResolveCEUsModalComponent } from './resolve-ceus-modal.component';
import { ApaAssessmentModalComponent } from './apa-assessment-modal.component';
import { CeuEvalModalComponent } from "./ceu-eval-modal.component";

@Component({
  selector: 'bxl-conference-event-summaries',
  templateUrl: 'conference-event-summaries.component.html',
})
export class ConferenceEventSummariesComponent implements OnInit {
  initialized = false;
  conferenceId: number;
  conference: ConferenceViewModel;
  events: CEUEventSummary[];
  ParticipationModality = ParticipationModality;
  ParticipationModalityEnum = Enums.ParticipationModalityEnum;
  correctCount: number;
  incorrectCount: number;
  private ceuPipe: CEUCountPipe = new CEUCountPipe();

  constructor(private route: ActivatedRoute, private modalService: NgbModal,  private ceuService: CEUService, private organizationService: OrganizationService) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.conferenceId = +params['conferenceId'];

      this.organizationService.getConferenceBySlugBasic(this.conferenceId.toString()).subscribe((result) => {
        this.conference = result;
        this.getData();
      });
    });
  }
  getData() {
    this.ceuService.getEventSummariesForConference(this.conferenceId).subscribe((events:CEUEventSummary[]) => {
      this.events = Enumerable.from(events).where(x=>this.ceuPipe.transform(x.ceus) > 0).orderBy(x=>x.ceuParticipationDate?0:1).toArray();
      this.correctCount = Enumerable.from(this.events).count((x) => x.ceuFeedbackSubmitted && x.metCEUCriteria);
      this.incorrectCount = Enumerable.from(this.events).count((x) =>x.ceuParticipationDate &&  (!x.ceuFeedbackSubmitted || !x.metCEUCriteria));
      this.initialized = true;
    });
  }

  addEval(evnt: CEUEventSummary) {
    const modalRef = this.modalService.open(ApaAssessmentModalComponent, { size: 'lg', windowClass: 'flyout', backdropClass: 'flyout', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.componentInstance.courseEventId = evnt.id;

    modalRef.result.then(
      (result) => {
        this.getData();
      },
      (reason) => {
        this.getData();
      }
    );
    return;
  }
  addFeedback(evnt: CEUEventSummary) {
    const modalRef = this.modalService.open(WriteReviewModalComponent, { size: 'lg', windowClass: 'flyout', backdropClass: 'flyout', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.componentInstance.courseEventId = evnt.id;
    modalRef.componentInstance.courseEvent = evnt;
    modalRef.componentInstance.markEventComplete = true;

    modalRef.result.then(
      (result) => {
        this.getData();
      },
      (reason) => {
        this.getData();
      }
    );
    return;
  }
  fixCriteria(evnt: CEUEventSummary) {
    const modalRef = this.modalService.open(ResolveCEUsModalComponent, { size: 'lg', windowClass: 'flyout', backdropClass: 'flyout', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.componentInstance.courseEventId = evnt.id;
    modalRef.componentInstance.courseEvent = evnt;
    modalRef.componentInstance.markEventComplete = true;

    modalRef.result.then(
      (result) => {
        this.getData();
      },
      (reason) => {
        this.getData();
      }
    );
    return;
  }

  public openEval(feedbackSurveyId: number, evnt: CEUEventSummary) {
    const modalRef = this.modalService.open(CeuEvalModalComponent, { size: 'lg', windowClass: 'flyout', backdropClass: 'flyout', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.componentInstance.courseEventId = evnt.id;
    modalRef.componentInstance.feedbackSurveyId = feedbackSurveyId;
    modalRef.componentInstance.eventTitle = evnt.title;

    modalRef.result.then(
      (result) => {
        this.getData();
      },
      (reason) => {
        this.getData();
      }
    );
    return;
  }
}
